import styled, { css } from 'styled-components';

import { MENU_LIST_GRID_TEMPLATE_COLUMNS, THREE_EQUAL_GRID_COLUMNS } from './constants';

export const MenuTileGridContainer = styled.div<{ $noPaddingTop?: boolean }>`
  margin: 0;

  padding-block-start: 2rem;
  padding-block-end: 5rem;
  padding-inline-start: 1rem;
  padding-inline-end: 1rem;

  ${({ $noPaddingTop }) =>
    $noPaddingTop &&
    css`
      padding-block-start: 0;
    `}

  ${Styles.desktop} {
    margin-block: 2rem;
    margin-inline: 3rem;

    padding: 0;
  }
`;

export const MenuListGridContainer = styled.div<{ $noPaddingTop?: boolean }>`
  margin: 0;
  ${({ $noPaddingTop }) =>
    $noPaddingTop
      ? css`
          padding-block-start: 0;
        `
      : css`
          padding-block-start: 0.75rem;
        `}

  ${Styles.desktop} {
    display: flex;
    justify-content: center;

    margin-block-start: 1.5rem;
    margin-block-end: 1.5rem;
    padding: 0;
  }
`;

const menuTileGridInnerStyles = css<{
  $enableDirectAccessToMenu?: boolean;
}>`
  display: grid;
  text-decoration: none;

  grid-gap: 1rem;
  grid-template-columns: 1fr 1fr;

  ${Styles.desktop} {
    grid-gap: 1.5rem;
    grid-template-columns: ${p =>
      p.$enableDirectAccessToMenu ? THREE_EQUAL_GRID_COLUMNS : MENU_LIST_GRID_TEMPLATE_COLUMNS};
    justify-content: center;

    width: ${Styles.layout.sectionMaxWidth};
  }
`;

export const MenuTileGridInner = styled.div<{
  $enableDirectAccessToMenu?: boolean;
}>`
  ${menuTileGridInnerStyles}
`;

export const MenuListGridInner = styled.div<{
  $enableDirectAccessToMenu?: boolean;
}>`
  ${menuTileGridInnerStyles}

  grid-gap: 0;
  grid-template-columns: 1fr;
`;
